import {useState, Outlet, Navigate} from 'react-router-dom'

const ProtectdRoutes = () => {
    const user = sessionStorage.getItem('user')
    return user ? <Outlet /> : <Navigate to='/'/>
}

export default ProtectdRoutes